
























import { Component, Vue } from 'vue-property-decorator';
import { NewsModule } from '@/store/modules/news/news.store';
import { NewsViewObject } from '@/types/apiServerContract';

import CreateNews from '@/components/dashboard/news/CreateNews.vue';
import EditNews from '@/components/dashboard/news/EditNews.vue';
import NewsStatistcs from '@/components/dashboard/news/NewsStatistics.vue';

@Component({
    components: {
        CreateNews,
        EditNews,
        NewsStatistcs
    }
})
export default class News extends Vue {
	loading: boolean = false;

	get News(): NewsViewObject[] {
	    return NewsModule.news;
	}

	async GetNews() {
	    try {
	        this.loading = true;
	        await NewsModule.GetNews();
	    } finally {
	        this.loading = false;
	    }
	}

	created() {
	    this.GetNews();
	}
}
